/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceItemSummary } from './InvoiceItemSummary';
import {
    InvoiceItemSummaryFromJSON,
    InvoiceItemSummaryFromJSONTyped,
    InvoiceItemSummaryToJSON,
    InvoiceItemSummaryToJSONTyped,
} from './InvoiceItemSummary';

/**
 * 
 * @export
 * @interface PagedResultInvoiceItemSummary
 */
export interface PagedResultInvoiceItemSummary {
    /**
     * 
     * @type {Array<InvoiceItemSummary>}
     * @memberof PagedResultInvoiceItemSummary
     */
    content: Array<InvoiceItemSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultInvoiceItemSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultInvoiceItemSummary
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PagedResultInvoiceItemSummary interface.
 */
export function instanceOfPagedResultInvoiceItemSummary(value: object): value is PagedResultInvoiceItemSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedResultInvoiceItemSummaryFromJSON(json: any): PagedResultInvoiceItemSummary {
    return PagedResultInvoiceItemSummaryFromJSONTyped(json, false);
}

export function PagedResultInvoiceItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResultInvoiceItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(InvoiceItemSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
    };
}

export function PagedResultInvoiceItemSummaryToJSON(json: any): PagedResultInvoiceItemSummary {
    return PagedResultInvoiceItemSummaryToJSONTyped(json, false);
}

export function PagedResultInvoiceItemSummaryToJSONTyped(value?: PagedResultInvoiceItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(InvoiceItemSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

